import { breakpoint } from 'helpers'

const hero = {
  el: {
    heroes: <NodeListOf<HTMLElement>>document.querySelectorAll('.hero'),
    breadcrumbsBackButton: <HTMLElement>document.querySelector('.breadcrumbs__back'),
  },

  init(): void {
    if (!this.el.heroes.length) return

    this.el.heroes.forEach((hero: HTMLElement) => {
      this.positionInfoItems(hero)
      window.addEventListener('resize', () => this.positionInfoItems(hero))
    })

    if (this.el.breadcrumbsBackButton) {
      this.el.breadcrumbsBackButton.addEventListener('click', this.handleBreadcrumbsBack)
    }
  },

  positionInfoItems(hero: HTMLElement): void {
    const heroSlideText = <HTMLElement>hero.querySelector('.hero__slides--text')
    const breadcrumbs = <HTMLElement>hero.querySelector('.breadcrumbs')
    const infoItems = <HTMLElement>hero.querySelector('.hero__slides--info-items')
    const isDesktop = window.innerWidth >= breakpoint.tablet

    if (!infoItems) return

    const infoItemsHeight = infoItems.offsetHeight
    const breadcrumbsHeight = breadcrumbs ? breadcrumbs.offsetHeight : 0

    if (isDesktop) {
      heroSlideText.style.paddingBottom = `${infoItemsHeight / 2 + breadcrumbsHeight}px`
      infoItems.style.marginTop = `-${infoItemsHeight / 2}px`
    } else {
      heroSlideText.removeAttribute('style')
      infoItems.removeAttribute('style')
    }
  },

  handleBreadcrumbsBack(): void {
    window.history.go(-1)
  },
}

export default hero
